import React, { useState } from 'react';
import { isUsernameTaken } from '../../../core/firebase/auth_service';

export default function Step1Username({ data, onNext, onBack, onLoginRedirect }) {
  const [username, setUsername] = useState(data.username || '');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const validate = (val) => {
    if (val.length < 3)  return 'Minimum 3 caractères';
    if (val.length > 30) return 'Maximum 30 caractères';
    if (!/^[a-zA-Z0-9_.]+$/.test(val)) return 'Lettres, chiffres, _ et . seulement';
    return '';
  };

  const handleChange = (e) => {
    const val = e.target.value.toLowerCase().replace(/\s/g, '');
    setUsername(val);
    setError(validate(val));
  };

  const handleNext = async () => {
    const validErr = validate(username);
    if (validErr) { setError(validErr); return; }
    setLoading(true);
    setError('');
    try {
      const taken = await isUsernameTaken(username);
      if (taken) {
        setError('Ce nom d\'utilisateur est déjà pris.');
      } else {
        onNext({ username });
      }
    } catch (err) {
      console.error('isUsernameTaken error:', err);
      setError('Erreur réseau, réessayez.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.topBar}>
        <button style={styles.back} onClick={onBack}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span style={styles.stepLabel}>Create Account (1/4)</span>
        <div style={{ width: 36 }} />
      </div>

      <div style={styles.content}>
        <h2 style={styles.title}>Nom d'utilisateur</h2>
        <p style={styles.sub}>Choisissez un nom unique pour votre compte</p>

        <div style={styles.inputWrapper}>
          <span style={styles.at}>@</span>
          <input
            style={styles.input}
            placeholder="nom_utilisateur"
            value={username}
            onChange={handleChange}
            autoFocus
            autoCapitalize="none"
            autoCorrect="off"
          />
        </div>

        {error ? (
          <p style={styles.error}>{error}</p>
        ) : username.length >= 3 ? (
          <p style={styles.ok}>Disponible</p>
        ) : null}
      </div>

      <div style={styles.bottom}>
        <button
          style={{ ...styles.btnNext, opacity: username.length < 3 || loading ? 0.5 : 1 }}
          onClick={handleNext}
          disabled={username.length < 3 || loading}
        >
          {loading ? 'Vérification...' : 'Next'}
        </button>
        <button style={styles.loginLink} onClick={onLoginRedirect}>
          I already have an account
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f5f7ff', display: 'flex', flexDirection: 'column', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  topBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px' },
  back: { background: 'none', border: 'none', cursor: 'pointer', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  stepLabel: { color: '#333', fontSize: 15, fontWeight: 600 },
  content: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 24px 20px' },
  title: { fontSize: 26, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 },
  sub: { fontSize: 14, color: '#888', marginBottom: 40, textAlign: 'center' },
  inputWrapper: { display: 'flex', alignItems: 'center', background: '#fff', border: '1.5px solid #dde0f0', borderRadius: 14, padding: '0 16px', width: '100%', maxWidth: 380, height: 54 },
  at: { color: '#999', fontSize: 18, marginRight: 8 },
  input: { flex: 1, border: 'none', outline: 'none', fontSize: 16, color: '#222', background: 'transparent' },
  error: { color: '#e74c3c', fontSize: 13, marginTop: 10 },
  ok: { color: '#27ae60', fontSize: 13, marginTop: 10, fontWeight: 500 },
  bottom: { padding: '0 24px 40px', display: 'flex', flexDirection: 'column', gap: 14, alignItems: 'center' },
  btnNext: { background: '#3d5ef5', color: '#fff', border: 'none', borderRadius: 14, height: 54, fontSize: 16, fontWeight: 600, cursor: 'pointer', width: '100%', maxWidth: 480 },
  loginLink: { background: 'none', border: 'none', color: '#3d5ef5', fontSize: 14, fontWeight: 500, cursor: 'pointer' },
};
